// import React, { useState } from 'react';
// import { motion, AnimatePresence } from 'framer-motion';

// /* ─────────────────────────────────────────────
//    SVG Icons
// ───────────────────────────────────────────── */
// const UploadIcon = () => (
//   <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 68 68">
//     <g>
//       <path fill="#fcb910" d="M61.054 35.45v-16.5a3 3 0 0 0-3-3h-48a3 3 0 0 0-3 3v16.5z" />
//       <path fill="#e5e8f9" d="M13.903 36.28V8.407A3.368 3.368 0 0 1 17.26 5.05h33.58a3.358 3.358 0 0 1 3.358 3.358V36.28z" />
//       <path fill="#ffcc33" d="M2.424 27.265A2.003 2.003 0 0 1 4.4 24.95h13.42c.755 0 1.445.426 1.784 1.1l2.913 5.802a1.99 1.99 0 0 0 1.779 1.098h39.309a1.992 1.992 0 0 1 1.956 2.387c-.616 3.043-1.986 9.886-5.022 25.189a3.008 3.008 0 0 1-2.944 2.424H10.623a3 3 0 0 1-2.963-2.532L2.424 27.265z" />
//       <path fill="#ff4848" d="M43.15 11.95h-18.2a.75.75 0 0 1 0-1.5h18.2a.75.75 0 0 1 0 1.5z" />
//     </g>
//   </svg>
// );

// const LinkedInIcon = () => (
//   <svg
//     xmlns="http://www.w3.org/2000/svg"
//     width="40"
//     height="40"
//     viewBox="0 0 176 176"
//   >
//     <g>
//       <rect width="176" height="176" fill="#0077b5" rx="24" />
//       <g fill="#ffffff">
//         <path d="M63.4 48a15 15 0 1 1-15-15 15 15 0 0 1 15 15z" />
//         <path d="M60 73v66.27a3.71 3.71 0 0 1-3.71 3.73H40.48a3.71 3.71 0 0 1-3.72-3.72V73a3.72 3.72 0 0 1 3.72-3.72h15.81A3.72 3.72 0 0 1 60 73z" />
//         <path d="M142.64 107.5v32.08a3.41 3.41 0 0 1-3.42 3.42h-17a3.41 3.41 0 0 1-3.42-3.42v-31.09c0-4.64 1.36-20.32-12.13-20.32-10.45 0-12.58 10.73-13 15.55v35.86A3.42 3.42 0 0 1 90.3 143H73.88a3.41 3.41 0 0 1-3.41-3.42V72.71a3.41 3.41 0 0 1 3.41-3.42H90.3a3.42 3.42 0 0 1 3.42 3.42v5.78c3.88-5.82 9.63-10.31 21.9-10.31 27.18 0 27.02 25.38 27.02 39.32z" />
//       </g>
//     </g>
//   </svg>
// );

// const ScratchIcon = () => (
//   <svg xmlns="http://www.w3.org/2000/svg" version="1.1" width="40" height="40" x="0" y="0" viewBox="0 0 96 96"><g><rect width="69.72" height="94" x="18.14" y="1" fill="#737ec5" rx="3.36" opacity="1" data-original="#737ec5"></rect><rect width="69.72" height="94" x="13.65" y="1" fill="#b4c9e8" rx="3.36" opacity="1" data-original="#b4c9e8"></rect><path fill="#ffffff" d="M78.23 4.36v27.81h5.14V4.36A3.35 3.35 0 0 0 80 1h-5.37a3.57 3.57 0 0 1 3.6 3.36z" opacity="1" data-original="#ffffff"></path><path fill="#91b0e8" d="M78.23 76.48v15.16A3.35 3.35 0 0 1 74.87 95H59.73a4.3 4.3 0 0 0 1.27-.88c17.68-17.69 16.77-16.61 17.23-17.64z" opacity="1" data-original="#91b0e8"></path><path fill="#737ec5" d="M78.23 82.36v9.28A3.35 3.35 0 0 1 74.87 95h-9.26z" opacity="1" data-original="#737ec5"></path><path fill="#e6ecf2" d="M78.25 4.62c0 75.84.18 70.66-.39 71.86-.44 1 .48-.08-16.88 17.27A4.27 4.27 0 0 1 58 95H11.77a3.63 3.63 0 0 1-3.63-3.62V4.62A3.63 3.63 0 0 1 11.77 1h62.86a3.62 3.62 0 0 1 3.62 3.62z" opacity="1" data-original="#e6ecf2" class=""></path><path fill="#ffffff" d="M43.38 9.75V55.8a2.75 2.75 0 0 0 2.74 2.75h10a2.75 2.75 0 0 0 1.94-.8l13.4-13.39a2.79 2.79 0 0 0 .8-2V9.75A2.75 2.75 0 0 0 69.5 7H46.12a2.75 2.75 0 0 0-2.74 2.75z" opacity="1" data-original="#ffffff"></path><path fill="#d2206e" d="M39.42 1v94H11.77a3.63 3.63 0 0 1-3.63-3.62V4.62A3.63 3.63 0 0 1 11.77 1z" opacity="1" data-original="#d2206e"></path><path fill="#a0116e" d="M39.42 65.94V95H11.77a3.63 3.63 0 0 1-3.63-3.62V62.32a3.63 3.63 0 0 0 3.63 3.62z" opacity="1" data-original="#a0116e"></path><path fill="#ff526e" d="M39.42 1v94h-17.5a3.62 3.62 0 0 1-3.62-3.62V4.62A3.62 3.62 0 0 1 21.92 1z" opacity="1" data-original="#ff526e" class=""></path><rect width="9.12" height="33.63" x="24.3" y="55.38" fill="#ff9d87" rx="1.75" opacity="1" data-original="#ff9d87"></rect><path fill="#bec9d9" d="M77.86 76.48c-.44 1 .48-.08-16.88 17.27a3.83 3.83 0 0 1-1.25.86V80.1a3.62 3.62 0 0 1 3.62-3.62z" opacity="1" data-original="#bec9d9"></path><path fill="#8ad7ff" d="M33.94 7.91v22.92a2.32 2.32 0 0 1-2.31 2.32H15.18a2.32 2.32 0 0 1-2.32-2.32V7.91a2.31 2.31 0 0 1 2.32-2.31h16.45a2.31 2.31 0 0 1 2.31 2.31z" opacity="1" data-original="#8ad7ff" class=""></path><circle cx="23.4" cy="16.74" r="5.48" fill="#3f3c6a" opacity="1" data-original="#3f3c6a" class=""></circle><path fill="#3f3c6a" d="M33.94 30.83a2.33 2.33 0 0 1-2.32 2.32H15.18a2.32 2.32 0 0 1-2.32-2.32 5.39 5.39 0 0 1 .52-2.33 11.14 11.14 0 0 1 20 0 5.38 5.38 0 0 1 .56 2.33z" opacity="1" data-original="#3f3c6a" class=""></path><path fill="#5f60b1" d="M52 19.06a6.45 6.45 0 1 1 5.22-10.28A1 1 0 1 1 55.61 10a4.44 4.44 0 1 0 .12 5.13 1 1 0 1 1 1.65 1.12A6.42 6.42 0 0 1 52 19.06zM60.75 18.49l-2.85-6a1 1 0 0 1 .48-1.33 1 1 0 0 1 1.33.47l1.94 4.07 1.94-4.07a1 1 0 0 1 1.8.86l-2.84 6a1 1 0 0 1-1.8 0z" opacity="1" data-original="#5f60b1" class=""></path><rect width="21.08" height="6.47" x="12.86" y="59.47" fill="#8ad7ff" rx="1.77" opacity="1" data-original="#8ad7ff" class=""></rect><rect width="21.08" height="6.47" x="12.86" y="71.16" fill="#53cd88" rx="1.77" opacity="1" data-original="#53cd88"></rect><rect width="7.42" height="6.47" x="12.86" y="82.84" fill="#ffca6e" rx="1.77" opacity="1" data-original="#ffca6e"></rect><rect width="7.42" height="6.47" x="26.52" y="82.84" fill="#ffca6e" rx="1.77" opacity="1" data-original="#ffca6e"></rect><g fill="#5f60b1"><path d="M33.94 41.15H12.86a1 1 0 0 1 0-2h21.08a1 1 0 0 1 0 2zM33.94 46.31H12.86a1 1 0 0 1 0-2h21.08a1 1 0 0 1 0 2zM28.28 51.48H12.86a1 1 0 0 1 0-2h15.42a1 1 0 0 1 0 2zM70.43 27H46.6a1 1 0 0 1 0-2h23.83a1 1 0 0 1 0 2zM70.43 31.84H46.6a1 1 0 0 1 0-2h23.83a1 1 0 0 1 0 2zM70.43 36.7H46.6a1 1 0 0 1 0-2h23.83a1 1 0 0 1 0 2zM55.06 41.55H46.6a1 1 0 0 1 0-2h8.46a1 1 0 0 1 0 2zM63 41.55h-2.54a1 1 0 1 1 0-2H63a1 1 0 0 1 0 2z" fill="#5f60b1" opacity="1" data-original="#5f60b1" class=""></path></g><path fill="#53cd88" d="M48.51 51.89H46.6a1 1 0 0 1 0-2h1.91a1 1 0 1 1 0 2zM48.51 58.54H46.6a1 1 0 0 1 0-2h1.91a1 1 0 0 1 0 2zM48.51 65.19H46.6a1 1 0 1 1 0-2h1.91a1 1 0 0 1 0 2zM48.51 71.84H46.6a1 1 0 1 1 0-2h1.91a1 1 0 0 1 0 2z" opacity="1" data-original="#53cd88"></path><path fill="#5f60b1" d="M70.43 51.89H54.05a1 1 0 0 1 0-2h16.38a1 1 0 0 1 0 2zM70.43 58.54H54.05a1 1 0 0 1 0-2h16.38a1 1 0 0 1 0 2zM70.43 65.19H54.05a1 1 0 0 1 0-2h16.38a1 1 0 0 1 0 2zM70.43 71.84H54.05a1 1 0 0 1 0-2h16.38a1 1 0 0 1 0 2zM53 81.8h-6.4a1 1 0 0 1 0-2H53a1 1 0 1 1 0 2zM53 86.55h-6.4a1 1 0 0 1 0-2H53a1 1 0 1 1 0 2zM53 91.3h-6.4a1 1 0 0 1 0-2H53a1 1 0 1 1 0 2z" opacity="1" data-original="#5f60b1" class=""></path></g></svg>
// );

// const SparkleIcon = () => (
//   <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
//     <path d="M8 1v14M1 8h14M3.5 3.5l9 9M12.5 3.5l-9 9" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" opacity="0.6"/>
//   </svg>
// );

// /* ─────────────────────────────────────────────
//    Card Data
// ───────────────────────────────────────────── */
// const METHODS = [
//   {
//     id: 'upload',
//     icon: <UploadIcon />,
//     label: 'FASTEST',
//     title: 'Upload Resume',
//     subtitle: 'PDF or DOCX',
//     desc: 'AI reads your existing resume and extracts everything — experience, skills, education — in seconds.',
//     cta: 'Select File',
//     accent: '#00C9A7',
//     accentDark: '#00FFD1',
//     tag: '~10 sec',
//   },
//   {
//     id: 'linkedin',
//     icon: <LinkedInIcon />,
//     label: 'POPULAR',
//     title: 'LinkedIn Import',
//     subtitle: 'Auto-fill from profile',
//     desc: 'Connect once. We pull your entire professional history from LinkedIn into your new resume.',
//     cta: 'Connect LinkedIn',
//     accent: '#0A66C2',
//     accentDark: '#4D9FFF',
//     tag: '~30 sec',
//   },
//   {
//     id: 'scratch',
//     icon: <ScratchIcon />,
//     label: 'AI GUIDED',
//     title: 'Build from Scratch',
//     subtitle: 'Step by step with AI',
//     desc: 'Answer a few smart questions. AI writes tailored bullet points and optimises every section for ATS.',
//     cta: 'Start Building',
//     accent: '#7C3AED',
//     accentDark: '#A78BFA',
//     tag: '~5 min',
//   },
// ];

// /* ─────────────────────────────────────────────
//    Component
// ───────────────────────────────────────────── */
// const ResumeBuilderLanding = ({ onContinue, theme = 'dark' }) => {
//   const [selectedMethod, setSelectedMethod] = useState(null);
//   const [hovered, setHovered] = useState(null);
//   const isDark = theme === 'dark';

//   const handleSelect = (id) => {
//     setSelectedMethod(id);
//     setTimeout(() => {
//       onContinue?.({ method: id, track: null, experience: null });
//     }, 500);
//   };

//   return (
//     <>
//       <style>{`
//         @import url('https://fonts.googleapis.com/css2?family=Syne:wght@400;500;600;700;800&family=DM+Sans:wght@300;400;500;600&family=Changa+One:ital@0;1&display=swap');

//         .rbl-root {
//           font-family: 'DM Sans', sans-serif;
//           min-height: calc(100vh - 64px);
//           display: flex;
//           flex-direction: column;
//           align-items: center;
//           justify-content: center;
//           padding: 88px 24px 64px;
//           position: relative;
//           overflow: hidden;
//           transition: background 0.4s ease, color 0.4s ease;
//         }

//         /* ── DARK ── */
//         .rbl-root.dark {
//           background: #050508;
//           color: #E8E6F0;
//         }
//         .rbl-root.dark .rbl-bg-orb-1 {
//           background: radial-gradient(circle, rgba(0,201,167,0.07) 0%, transparent 65%);
//         }
//         .rbl-root.dark .rbl-bg-orb-2 {
//           background: radial-gradient(circle, rgba(124,58,237,0.08) 0%, transparent 65%);
//         }
//         .rbl-root.dark .rbl-bg-grid {
//           background-image:
//             linear-gradient(rgba(255,255,255,0.025) 1px, transparent 1px),
//             linear-gradient(90deg, rgba(255,255,255,0.025) 1px, transparent 1px);
//         }
//         .rbl-root.dark .rbl-badge {
//           background: rgba(0,201,167,0.1);
//           border: 1px solid rgba(0,201,167,0.25);
//           color: #00FFD1;
//         }
//         .rbl-root.dark .rbl-title {
//           color: #F0EEF8;
//         }
//         .rbl-root.dark .rbl-title span {
//           background: linear-gradient(135deg, #00FFD1 0%, #60A5FA 60%, #A78BFA 100%);
//           -webkit-background-clip: text;
//           background-clip: text;
//           -webkit-text-fill-color: transparent;
//         }
//         .rbl-root.dark .rbl-sub {
//           color: #6E6B80;
//         }
//         .rbl-root.dark .rbl-card {
//           background: #0D0D12;
//           border: 1px solid rgba(255,255,255,0.06);
//         }
//         .rbl-root.dark .rbl-card:hover,
//         .rbl-root.dark .rbl-card.active {
//           border-color: var(--card-accent);
//           background: #0D0D12;
//         }
//         .rbl-root.dark .rbl-card-label {
//           color: var(--card-accent);
//           background: color-mix(in srgb, var(--card-accent) 12%, transparent);
//           border: 1px solid color-mix(in srgb, var(--card-accent) 30%, transparent);
//         }
//         .rbl-root.dark .rbl-card-title {
//           color: #EDEAF5;
//         }
//         .rbl-root.dark .rbl-card-sub {
//           color: #4A4760;
//         }
//         .rbl-root.dark .rbl-card-desc {
//           color: #6E6B80;
//         }
//         .rbl-root.dark .rbl-card-divider {
//           background: rgba(255,255,255,0.06);
//         }
//         .rbl-root.dark .rbl-card-tag {
//           color: #4A4760;
//         }
//         .rbl-root.dark .rbl-card-cta {
//           background: var(--card-accent);
//           color: #050508;
//         }
//         .rbl-root.dark .rbl-card-cta:hover {
//           filter: brightness(1.1);
//         }
//         .rbl-root.dark .rbl-card-icon-wrap {
//           color: var(--card-accent);
//         }

//         /* ── LIGHT ── */
//         .rbl-root.light {
//           background: #F5F4F8;
//           color: #1A1828;
//         }
//         .rbl-root.light .rbl-bg-orb-1 {
//           background: radial-gradient(circle, rgba(0,201,167,0.12) 0%, transparent 65%);
//         }
//         .rbl-root.light .rbl-bg-orb-2 {
//           background: radial-gradient(circle, rgba(124,58,237,0.09) 0%, transparent 65%);
//         }
//         .rbl-root.light .rbl-bg-grid {
//           background-image:
//             linear-gradient(rgba(0,0,0,0.04) 1px, transparent 1px),
//             linear-gradient(90deg, rgba(0,0,0,0.04) 1px, transparent 1px);
//         }
//         .rbl-root.light .rbl-badge {
//           background: rgba(0,150,120,0.08);
//           border: 1px solid rgba(0,150,120,0.2);
//           color: #007A5E;
//         }
//         .rbl-root.light .rbl-title {
//           color: #1A1828;
//         }
//         .rbl-root.light .rbl-title span {
//           background: linear-gradient(135deg, #009B7D 0%, #2563EB 60%, #7C3AED 100%);
//           -webkit-background-clip: text;
//           background-clip: text;
//           -webkit-text-fill-color: transparent;
//         }
//         .rbl-root.light .rbl-sub {
//           color: #8B879E;
//         }
//         .rbl-root.light .rbl-card {
//           background: #FFFFFF;
//           border: 1px solid rgba(0,0,0,0.07);
//           box-shadow: 0 2px 16px rgba(0,0,0,0.05);
//         }
//         .rbl-root.light .rbl-card:hover,
//         .rbl-root.light .rbl-card.active {
//           border-color: var(--card-accent-light);
//           background: #FFFFFF;
//           box-shadow: 0 8px 40px color-mix(in srgb, var(--card-accent-light) 15%, transparent);
//         }
//         .rbl-root.light .rbl-card-label {
//           color: var(--card-accent-light);
//           background: color-mix(in srgb, var(--card-accent-light) 10%, transparent);
//           border: 1px solid color-mix(in srgb, var(--card-accent-light) 25%, transparent);
//         }
//         .rbl-root.light .rbl-card-title {
//           color: #1A1828;
//         }
//         .rbl-root.light .rbl-card-sub {
//           color: #B0ACC4;
//         }
//         .rbl-root.light .rbl-card-desc {
//           color: #8B879E;
//         }
//         .rbl-root.light .rbl-card-divider {
//           background: rgba(0,0,0,0.06);
//         }
//         .rbl-root.light .rbl-card-tag {
//           color: #B0ACC4;
//         }
//         .rbl-root.light .rbl-card-cta {
//           background: var(--card-accent-light);
//           color: #fff;
//         }
//         .rbl-root.light .rbl-card-cta:hover {
//           filter: brightness(0.92);
//         }
//         .rbl-root.light .rbl-card-icon-wrap {
//           color: var(--card-accent-light);
//         }

//         /* ── SHARED ── */
//         .rbl-bg-orb-1, .rbl-bg-orb-2 {
//           position: absolute;
//           border-radius: 50%;
//           pointer-events: none;
//         }
//         .rbl-bg-orb-1 {
//           width: 700px; height: 700px;
//           top: -200px; left: -200px;
//         }
//         .rbl-bg-orb-2 {
//           width: 600px; height: 600px;
//           bottom: -200px; right: -100px;
//         }
//         .rbl-bg-grid {
//           position: absolute;
//           inset: 0;
//           background-size: 40px 40px;
//           pointer-events: none;
//           mask-image: radial-gradient(ellipse 80% 80% at 50% 50%, black, transparent);
//           -webkit-mask-image: radial-gradient(ellipse 80% 80% at 50% 50%, black, transparent);
//         }

//         .rbl-inner {
//           position: relative;
//           z-index: 1;
//           width: 100%;
//           max-width: 1100px;
//         }

//         .rbl-header {
//           text-align: center;
//           margin-bottom: 56px;
//         }

//         .rbl-badge {
//           display: inline-flex;
//           align-items: center;
//           gap: 7px;
//           font-family: 'DM Sans', sans-serif;
//           font-size: 11px;
//           font-weight: 600;
//           letter-spacing: 0.12em;
//           text-transform: uppercase;
//           padding: 6px 14px;
//           border-radius: 100px;
//           margin-bottom: 24px;
//         }

//         .rbl-title {
//           font-family: "Changa One", sans-serif;
//           font-size: clamp(32px, 5vw, 52px);
//           font-weight: 400;
//           line-height: 1.1;
//           letter-spacing: -0.05em;
//           margin: 0 0 18px;
//         }

//         .rbl-sub {
//           font-size: 16px;
//           font-weight: 400;
//           line-height: 1.7;
//           max-width: 480px;
//           margin: 0 auto;
//         }

//         /* ── CARDS ── */
//         .rbl-cards {
//           display: grid;
//           grid-template-columns: repeat(3, 1fr);
//           gap: 20px;
//         }

//         .rbl-card {
//           border-radius: 20px;
//           padding: 28px 24px 24px;
//           cursor: pointer;
//           position: relative;
//           overflow: hidden;
//           transition: border-color 0.3s ease, box-shadow 0.3s ease, transform 0.3s ease;
//         }

//         .rbl-card-glow {
//           position: absolute;
//           inset: 0;
//           border-radius: 20px;
//           opacity: 0;
//           transition: opacity 0.4s ease;
//           pointer-events: none;
//           background: radial-gradient(ellipse at 50% 0%, var(--card-glow), transparent 70%);
//         }
//         .rbl-card:hover .rbl-card-glow,
//         .rbl-card.active .rbl-card-glow {
//           opacity: 1;
//         }

//         .rbl-card-top {
//           display: flex;
//           align-items: flex-start;
//           justify-content: space-between;
//           margin-bottom: 20px;
//         }

//         .rbl-card-icon-wrap {
//           transition: transform 0.3s ease;
//         }
//         .rbl-card:hover .rbl-card-icon-wrap {
//           transform: scale(1.08) translateY(-2px);
//         }

//         .rbl-card-label {
//           font-family: 'DM Sans', sans-serif;
//           font-size: 10px;
//           font-weight: 700;
//           letter-spacing: 0.1em;
//           padding: 4px 10px;
//           border-radius: 100px;
//           align-self: flex-start;
//           margin-top: 2px;
//         }

//         .rbl-card-title {
//           font-family: 'Syne', sans-serif;
//           font-size: 20px;
//           font-weight: 700;
//           margin: 0 0 4px;
//           letter-spacing: -0.02em;
//         }

//         .rbl-card-sub {
//           font-size: 12px;
//           font-weight: 500;
//           letter-spacing: 0.02em;
//           margin-bottom: 14px;
//         }

//         .rbl-card-desc {
//           font-size: 13.5px;
//           line-height: 1.65;
//           margin-bottom: 22px;
//         }

//         .rbl-card-divider {
//           height: 1px;
//           margin-bottom: 18px;
//         }

//         .rbl-card-bottom {
//           display: flex;
//           align-items: center;
//           justify-content: space-between;
//           gap: 12px;
//         }

//         .rbl-card-cta {
//           flex: 1;
//           padding: 11px 18px;
//           border-radius: 10px;
//           font-family: 'DM Sans', sans-serif;
//           font-size: 14px;
//           font-weight: 600;
//           cursor: pointer;
//           border: none;
//           transition: filter 0.2s ease, transform 0.2s ease;
//           letter-spacing: 0.01em;
//         }
//         .rbl-card-cta:hover {
//           transform: translateY(-1px);
//         }
//         .rbl-card-cta:active {
//           transform: translateY(0);
//         }

//         .rbl-card-tag {
//           font-size: 12px;
//           font-weight: 500;
//           white-space: nowrap;
//           display: flex;
//           align-items: center;
//           gap: 4px;
//         }

//         /* ── LOADING OVERLAY ── */
//         .rbl-overlay {
//           position: fixed;
//           inset: 0;
//           background: rgba(5,5,8,0.6);
//           backdrop-filter: blur(6px);
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           z-index: 9999;
//         }
//         .rbl-spinner {
//           width: 48px;
//           height: 48px;
//           border: 3px solid rgba(255,255,255,0.1);
//           border-top-color: #00FFD1;
//           border-radius: 50%;
//           animation: spin 0.8s linear infinite;
//         }
//         @keyframes spin { to { transform: rotate(360deg); } }

//         /* ── RESPONSIVE ── */
//         @media (max-width: 900px) {
//           .rbl-cards {
//             grid-template-columns: 1fr;
//             max-width: 480px;
//             margin: 0 auto;
//           }
//         }
//       `}</style>

//       <div className={`rbl-root ${theme}`}>
//         {/* Background */}
//         <div className="rbl-bg-orb-1" />
//         <div className="rbl-bg-orb-2" />
//         <div className="rbl-bg-grid" />

//         <div className="rbl-inner">
//           {/* Header */}
//           <motion.div
//             className="rbl-header"
//             initial={{ opacity: 0, y: 24 }}
//             animate={{ opacity: 1, y: 0 }}
//             transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
//           >
//             <div className="rbl-badge">
//               <SparkleIcon />
//               ATS Resume Builder
//             </div>
//             <h1 className="rbl-title">
//               How would you like<br />
//               <span>to get started?</span>
//             </h1>
//             <p className="rbl-sub">
//               Pick the fastest path to your new resume. Everything can be edited after.
//             </p>
//           </motion.div>

//           {/* Cards */}
//           <div className="rbl-cards">
//             {METHODS.map((m, i) => {
              
//               const isHov = hovered === m.id;
//               const isSel = selectedMethod === m.id;

//               return (
//                 <motion.div
//                   key={m.id}
//                   className={`rbl-card ${isHov || isSel ? 'active' : ''}`}
//                   style={{
//                     '--card-accent': m.accentDark,
//                     '--card-accent-light': m.accent,
//                     '--card-glow': isDark
//                       ? `color-mix(in srgb, ${m.accentDark} 18%, transparent)`
//                       : `color-mix(in srgb, ${m.accent} 12%, transparent)`,
//                   }}
//                   initial={{ opacity: 0, y: 32 }}
//                   animate={{ opacity: 1, y: 0 }}
//                   transition={{
//                     delay: 0.15 + i * 0.1,
//                     duration: 0.55,
//                     ease: [0.22, 1, 0.36, 1],
//                   }}
//                   whileHover={{ y: -6 }}
//                   whileTap={{ scale: 0.985 }}
//                   onHoverStart={() => setHovered(m.id)}
//                   onHoverEnd={() => setHovered(null)}
//                   onClick={() => handleSelect(m.id)}
//                 >
//                   {/* Glow layer */}
//                   <div className="rbl-card-glow" />

//                   {/* Top row */}
//                   <div className="rbl-card-top">
//                     <div className="rbl-card-icon-wrap">{m.icon}</div>
//                     <span className="rbl-card-label">{m.label}</span>
//                   </div>

//                   <div className="rbl-card-title">{m.title}</div>
//                   <div className="rbl-card-sub">{m.subtitle}</div>
//                   <p className="rbl-card-desc">{m.desc}</p>

//                   <div className="rbl-card-divider" />

//                   <div className="rbl-card-bottom">
//                     <button
//                       className="rbl-card-cta"
//                       onClick={(e) => { e.stopPropagation(); handleSelect(m.id); }}
//                     >
//                       {m.cta} →
//                     </button>
//                     <span className="rbl-card-tag">⏱ {m.tag}</span>
//                   </div>
//                 </motion.div>
//               );
//             })}
//           </div>
//         </div>

//         {/* Loading overlay */}
//         <AnimatePresence>
//           {selectedMethod && (
//             <motion.div
//               className="rbl-overlay"
//               initial={{ opacity: 0 }}
//               animate={{ opacity: 1 }}
//               exit={{ opacity: 0 }}
//             >
//               <div className="rbl-spinner" />
//             </motion.div>
//           )}
//         </AnimatePresence>
//       </div>
//     </>
//   );
// };

// export default ResumeBuilderLanding;

import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

// /* ─────────────────────────────────────────────
//    SVG Icons
// ───────────────────────────────────────────── */
const UploadIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 68 68">
    <g>
      <path fill="#fcb910" d="M61.054 35.45v-16.5a3 3 0 0 0-3-3h-48a3 3 0 0 0-3 3v16.5z" />
      <path fill="#e5e8f9" d="M13.903 36.28V8.407A3.368 3.368 0 0 1 17.26 5.05h33.58a3.358 3.358 0 0 1 3.358 3.358V36.28z" />
      <path fill="#ffcc33" d="M2.424 27.265A2.003 2.003 0 0 1 4.4 24.95h13.42c.755 0 1.445.426 1.784 1.1l2.913 5.802a1.99 1.99 0 0 0 1.779 1.098h39.309a1.992 1.992 0 0 1 1.956 2.387c-.616 3.043-1.986 9.886-5.022 25.189a3.008 3.008 0 0 1-2.944 2.424H10.623a3 3 0 0 1-2.963-2.532L2.424 27.265z" />
      <path fill="#ff4848" d="M43.15 11.95h-18.2a.75.75 0 0 1 0-1.5h18.2a.75.75 0 0 1 0 1.5z" />
    </g>
  </svg>
);

const LinkedInIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="40"
    height="40"
    viewBox="0 0 176 176"
  >
    <g>
      <rect width="176" height="176" fill="#0077b5" rx="24" />
      <g fill="#ffffff">
        <path d="M63.4 48a15 15 0 1 1-15-15 15 15 0 0 1 15 15z" />
        <path d="M60 73v66.27a3.71 3.71 0 0 1-3.71 3.73H40.48a3.71 3.71 0 0 1-3.72-3.72V73a3.72 3.72 0 0 1 3.72-3.72h15.81A3.72 3.72 0 0 1 60 73z" />
        <path d="M142.64 107.5v32.08a3.41 3.41 0 0 1-3.42 3.42h-17a3.41 3.41 0 0 1-3.42-3.42v-31.09c0-4.64 1.36-20.32-12.13-20.32-10.45 0-12.58 10.73-13 15.55v35.86A3.42 3.42 0 0 1 90.3 143H73.88a3.41 3.41 0 0 1-3.41-3.42V72.71a3.41 3.41 0 0 1 3.41-3.42H90.3a3.42 3.42 0 0 1 3.42 3.42v5.78c3.88-5.82 9.63-10.31 21.9-10.31 27.18 0 27.02 25.38 27.02 39.32z" />
      </g>
    </g>
  </svg>
);

const ScratchIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" version="1.1" width="40" height="40" x="0" y="0" viewBox="0 0 96 96"><g><rect width="69.72" height="94" x="18.14" y="1" fill="#737ec5" rx="3.36" opacity="1" data-original="#737ec5"></rect><rect width="69.72" height="94" x="13.65" y="1" fill="#b4c9e8" rx="3.36" opacity="1" data-original="#b4c9e8"></rect><path fill="#ffffff" d="M78.23 4.36v27.81h5.14V4.36A3.35 3.35 0 0 0 80 1h-5.37a3.57 3.57 0 0 1 3.6 3.36z" opacity="1" data-original="#ffffff"></path><path fill="#91b0e8" d="M78.23 76.48v15.16A3.35 3.35 0 0 1 74.87 95H59.73a4.3 4.3 0 0 0 1.27-.88c17.68-17.69 16.77-16.61 17.23-17.64z" opacity="1" data-original="#91b0e8"></path><path fill="#737ec5" d="M78.23 82.36v9.28A3.35 3.35 0 0 1 74.87 95h-9.26z" opacity="1" data-original="#737ec5"></path><path fill="#e6ecf2" d="M78.25 4.62c0 75.84.18 70.66-.39 71.86-.44 1 .48-.08-16.88 17.27A4.27 4.27 0 0 1 58 95H11.77a3.63 3.63 0 0 1-3.63-3.62V4.62A3.63 3.63 0 0 1 11.77 1h62.86a3.62 3.62 0 0 1 3.62 3.62z" opacity="1" data-original="#e6ecf2" class=""></path><path fill="#ffffff" d="M43.38 9.75V55.8a2.75 2.75 0 0 0 2.74 2.75h10a2.75 2.75 0 0 0 1.94-.8l13.4-13.39a2.79 2.79 0 0 0 .8-2V9.75A2.75 2.75 0 0 0 69.5 7H46.12a2.75 2.75 0 0 0-2.74 2.75z" opacity="1" data-original="#ffffff"></path><path fill="#d2206e" d="M39.42 1v94H11.77a3.63 3.63 0 0 1-3.63-3.62V4.62A3.63 3.63 0 0 1 11.77 1z" opacity="1" data-original="#d2206e"></path><path fill="#a0116e" d="M39.42 65.94V95H11.77a3.63 3.63 0 0 1-3.63-3.62V62.32a3.63 3.63 0 0 0 3.63 3.62z" opacity="1" data-original="#a0116e"></path><path fill="#ff526e" d="M39.42 1v94h-17.5a3.62 3.62 0 0 1-3.62-3.62V4.62A3.62 3.62 0 0 1 21.92 1z" opacity="1" data-original="#ff526e" class=""></path><rect width="9.12" height="33.63" x="24.3" y="55.38" fill="#ff9d87" rx="1.75" opacity="1" data-original="#ff9d87"></rect><path fill="#bec9d9" d="M77.86 76.48c-.44 1 .48-.08-16.88 17.27a3.83 3.83 0 0 1-1.25.86V80.1a3.62 3.62 0 0 1 3.62-3.62z" opacity="1" data-original="#bec9d9"></path><path fill="#8ad7ff" d="M33.94 7.91v22.92a2.32 2.32 0 0 1-2.31 2.32H15.18a2.32 2.32 0 0 1-2.32-2.32V7.91a2.31 2.31 0 0 1 2.32-2.31h16.45a2.31 2.31 0 0 1 2.31 2.31z" opacity="1" data-original="#8ad7ff" class=""></path><circle cx="23.4" cy="16.74" r="5.48" fill="#3f3c6a" opacity="1" data-original="#3f3c6a" class=""></circle><path fill="#3f3c6a" d="M33.94 30.83a2.33 2.33 0 0 1-2.32 2.32H15.18a2.32 2.32 0 0 1-2.32-2.32 5.39 5.39 0 0 1 .52-2.33 11.14 11.14 0 0 1 20 0 5.38 5.38 0 0 1 .56 2.33z" opacity="1" data-original="#3f3c6a" class=""></path><path fill="#5f60b1" d="M52 19.06a6.45 6.45 0 1 1 5.22-10.28A1 1 0 1 1 55.61 10a4.44 4.44 0 1 0 .12 5.13 1 1 0 1 1 1.65 1.12A6.42 6.42 0 0 1 52 19.06zM60.75 18.49l-2.85-6a1 1 0 0 1 .48-1.33 1 1 0 0 1 1.33.47l1.94 4.07 1.94-4.07a1 1 0 0 1 1.8.86l-2.84 6a1 1 0 0 1-1.8 0z" opacity="1" data-original="#5f60b1" class=""></path><rect width="21.08" height="6.47" x="12.86" y="59.47" fill="#8ad7ff" rx="1.77" opacity="1" data-original="#8ad7ff" class=""></rect><rect width="21.08" height="6.47" x="12.86" y="71.16" fill="#53cd88" rx="1.77" opacity="1" data-original="#53cd88"></rect><rect width="7.42" height="6.47" x="12.86" y="82.84" fill="#ffca6e" rx="1.77" opacity="1" data-original="#ffca6e"></rect><rect width="7.42" height="6.47" x="26.52" y="82.84" fill="#ffca6e" rx="1.77" opacity="1" data-original="#ffca6e"></rect><g fill="#5f60b1"><path d="M33.94 41.15H12.86a1 1 0 0 1 0-2h21.08a1 1 0 0 1 0 2zM33.94 46.31H12.86a1 1 0 0 1 0-2h21.08a1 1 0 0 1 0 2zM28.28 51.48H12.86a1 1 0 0 1 0-2h15.42a1 1 0 0 1 0 2zM70.43 27H46.6a1 1 0 0 1 0-2h23.83a1 1 0 0 1 0 2zM70.43 31.84H46.6a1 1 0 0 1 0-2h23.83a1 1 0 0 1 0 2zM70.43 36.7H46.6a1 1 0 0 1 0-2h23.83a1 1 0 0 1 0 2zM55.06 41.55H46.6a1 1 0 0 1 0-2h8.46a1 1 0 0 1 0 2zM63 41.55h-2.54a1 1 0 1 1 0-2H63a1 1 0 0 1 0 2z" fill="#5f60b1" opacity="1" data-original="#5f60b1" class=""></path></g><path fill="#53cd88" d="M48.51 51.89H46.6a1 1 0 0 1 0-2h1.91a1 1 0 1 1 0 2zM48.51 58.54H46.6a1 1 0 0 1 0-2h1.91a1 1 0 0 1 0 2zM48.51 65.19H46.6a1 1 0 1 1 0-2h1.91a1 1 0 0 1 0 2zM48.51 71.84H46.6a1 1 0 1 1 0-2h1.91a1 1 0 0 1 0 2z" opacity="1" data-original="#53cd88"></path><path fill="#5f60b1" d="M70.43 51.89H54.05a1 1 0 0 1 0-2h16.38a1 1 0 0 1 0 2zM70.43 58.54H54.05a1 1 0 0 1 0-2h16.38a1 1 0 0 1 0 2zM70.43 65.19H54.05a1 1 0 0 1 0-2h16.38a1 1 0 0 1 0 2zM70.43 71.84H54.05a1 1 0 0 1 0-2h16.38a1 1 0 0 1 0 2zM53 81.8h-6.4a1 1 0 0 1 0-2H53a1 1 0 1 1 0 2zM53 86.55h-6.4a1 1 0 0 1 0-2H53a1 1 0 1 1 0 2zM53 91.3h-6.4a1 1 0 0 1 0-2H53a1 1 0 1 1 0 2z" opacity="1" data-original="#5f60b1" class=""></path></g></svg>
);

const SparkleIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path d="M8 1v14M1 8h14M3.5 3.5l9 9M12.5 3.5l-9 9" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" opacity="0.6"/>
  </svg>
);

const METHODS = [
  {
    id: 'upload',
    icon: <UploadIcon />,
    label: 'FASTEST',
    title: 'Upload Resume',
    subtitle: 'PDF or DOCX',
    desc: 'AI reads your existing resume and extracts everything — experience, skills, education — in seconds.',
    cta: 'Select File',
    accent: '#00C9A7',
    accentDark: '#00FFD1',
    tag: '~10 sec',
  },
  {
    id: 'linkedin',
    icon: <LinkedInIcon />,
    label: 'POPULAR',
    title: 'LinkedIn Import',
    subtitle: 'Auto-fill from profile',
    desc: 'Connect once. We pull your entire professional history from LinkedIn into your new resume.',
    cta: 'Connect LinkedIn',
    accent: '#0A66C2',
    accentDark: '#4D9FFF',
    tag: '~30 sec',
  },
  {
    id: 'scratch',
    icon: <ScratchIcon />,
    label: 'AI GUIDED',
    title: 'Build from Scratch',
    subtitle: 'Step by step with AI',
    desc: 'Answer a few smart questions. AI writes tailored bullet points and optimises every section for ATS.',
    cta: 'Start Building',
    accent: '#7C3AED',
    accentDark: '#A78BFA',
    tag: '~5 min',
  },
];

const ResumeBuilderLanding = ({ onContinue, theme = 'dark' }) => {
  const [selectedMethod, setSelectedMethod] = useState(null);
  const [hovered, setHovered] = useState(null);
  const isDark = theme === 'dark';

  const handleSelect = (id) => {
    setSelectedMethod(id);
    setTimeout(() => {
      onContinue?.({ method: id });
    }, 500);
  };

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Syne:wght@400;500;600;700;800&family=DM+Sans:wght@300;400;500;600&family=Changa+One:ital@0;1&display=swap');

        .rbl-root {
          font-family: 'DM Sans', sans-serif;
          min-height: calc(100vh - 64px);
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          padding: 88px 24px 64px;
          position: relative;
          overflow: hidden;
          transition: background 0.4s ease, color 0.4s ease;
        }

        .rbl-root.dark {
          background: #050508;
          color: #E8E6F0;
        }
        .rbl-root.dark .rbl-bg-orb-1 {
          background: radial-gradient(circle, rgba(0,201,167,0.07) 0%, transparent 65%);
        }
        .rbl-root.dark .rbl-bg-orb-2 {
          background: radial-gradient(circle, rgba(124,58,237,0.08) 0%, transparent 65%);
        }
        .rbl-root.dark .rbl-bg-grid {
          background-image:
            linear-gradient(rgba(255,255,255,0.025) 1px, transparent 1px),
            linear-gradient(90deg, rgba(255,255,255,0.025) 1px, transparent 1px);
        }
        .rbl-root.dark .rbl-badge {
          background: rgba(0,201,167,0.1);
          border: 1px solid rgba(0,201,167,0.25);
          color: #00FFD1;
        }
        .rbl-root.dark .rbl-title {
          color: #F0EEF8;
        }
        .rbl-root.dark .rbl-title span {
          background: linear-gradient(135deg, #00FFD1 0%, #60A5FA 60%, #A78BFA 100%);
          -webkit-background-clip: text;
          background-clip: text;
          -webkit-text-fill-color: transparent;
        }
        .rbl-root.dark .rbl-sub {
          color: #6E6B80;
        }
        .rbl-root.dark .rbl-card {
          background: #0D0D12;
          border: 1px solid rgba(255,255,255,0.06);
        }
        .rbl-root.dark .rbl-card:hover,
        .rbl-root.dark .rbl-card.active {
          border-color: var(--card-accent);
          background: #0D0D12;
        }
        .rbl-root.dark .rbl-card-label {
          color: var(--card-accent);
          background: color-mix(in srgb, var(--card-accent) 12%, transparent);
          border: 1px solid color-mix(in srgb, var(--card-accent) 30%, transparent);
        }
        .rbl-root.dark .rbl-card-title {
          color: #EDEAF5;
        }
        .rbl-root.dark .rbl-card-sub {
          color: #4A4760;
        }
        .rbl-root.dark .rbl-card-desc {
          color: #6E6B80;
        }
        .rbl-root.dark .rbl-card-divider {
          background: rgba(255,255,255,0.06);
        }
        .rbl-root.dark .rbl-card-tag {
          color: #4A4760;
        }
        .rbl-root.dark .rbl-card-cta {
          background: var(--card-accent);
          color: #050508;
        }
        .rbl-root.dark .rbl-card-cta:hover {
          filter: brightness(1.1);
        }
        .rbl-root.dark .rbl-card-icon-wrap {
          color: var(--card-accent);
        }

        .rbl-root.light {
          background: #F5F4F8;
          color: #1A1828;
        }
        .rbl-root.light .rbl-bg-orb-1 {
          background: radial-gradient(circle, rgba(0,201,167,0.12) 0%, transparent 65%);
        }
        .rbl-root.light .rbl-bg-orb-2 {
          background: radial-gradient(circle, rgba(124,58,237,0.09) 0%, transparent 65%);
        }
        .rbl-root.light .rbl-bg-grid {
          background-image:
            linear-gradient(rgba(0,0,0,0.04) 1px, transparent 1px),
            linear-gradient(90deg, rgba(0,0,0,0.04) 1px, transparent 1px);
        }
        .rbl-root.light .rbl-badge {
          background: rgba(0,150,120,0.08);
          border: 1px solid rgba(0,150,120,0.2);
          color: #007A5E;
        }
        .rbl-root.light .rbl-title {
          color: #1A1828;
        }
        .rbl-root.light .rbl-title span {
          background: linear-gradient(135deg, #009B7D 0%, #2563EB 60%, #7C3AED 100%);
          -webkit-background-clip: text;
          background-clip: text;
          -webkit-text-fill-color: transparent;
        }
        .rbl-root.light .rbl-sub {
          color: #8B879E;
        }
        .rbl-root.light .rbl-card {
          background: #FFFFFF;
          border: 1px solid rgba(0,0,0,0.07);
          box-shadow: 0 2px 16px rgba(0,0,0,0.05);
        }
        .rbl-root.light .rbl-card:hover,
        .rbl-root.light .rbl-card.active {
          border-color: var(--card-accent-light);
          background: #FFFFFF;
          box-shadow: 0 8px 40px color-mix(in srgb, var(--card-accent-light) 15%, transparent);
        }
        .rbl-root.light .rbl-card-label {
          color: var(--card-accent-light);
          background: color-mix(in srgb, var(--card-accent-light) 10%, transparent);
          border: 1px solid color-mix(in srgb, var(--card-accent-light) 25%, transparent);
        }
        .rbl-root.light .rbl-card-title {
          color: #1A1828;
        }
        .rbl-root.light .rbl-card-sub {
          color: #B0ACC4;
        }
        .rbl-root.light .rbl-card-desc {
          color: #8B879E;
        }
        .rbl-root.light .rbl-card-divider {
          background: rgba(0,0,0,0.06);
        }
        .rbl-root.light .rbl-card-tag {
          color: #B0ACC4;
        }
        .rbl-root.light .rbl-card-cta {
          background: var(--card-accent-light);
          color: #fff;
        }
        .rbl-root.light .rbl-card-cta:hover {
          filter: brightness(0.92);
        }
        .rbl-root.light .rbl-card-icon-wrap {
          color: var(--card-accent-light);
        }

        .rbl-bg-orb-1, .rbl-bg-orb-2 {
          position: absolute;
          border-radius: 50%;
          pointer-events: none;
        }
        .rbl-bg-orb-1 {
          width: 700px; height: 700px;
          top: -200px; left: -200px;
        }
        .rbl-bg-orb-2 {
          width: 600px; height: 600px;
          bottom: -200px; right: -100px;
        }
        .rbl-bg-grid {
          position: absolute;
          inset: 0;
          background-size: 40px 40px;
          pointer-events: none;
          mask-image: radial-gradient(ellipse 80% 80% at 50% 50%, black, transparent);
          -webkit-mask-image: radial-gradient(ellipse 80% 80% at 50% 50%, black, transparent);
        }

        .rbl-inner {
          position: relative;
          z-index: 1;
          width: 100%;
          max-width: 1100px;
        }

        .rbl-header {
          text-align: center;
          margin-bottom: 56px;
        }

        .rbl-badge {
          display: inline-flex;
          align-items: center;
          gap: 7px;
          font-family: 'DM Sans', sans-serif;
          font-size: 11px;
          font-weight: 600;
          letter-spacing: 0.12em;
          text-transform: uppercase;
          padding: 6px 14px;
          border-radius: 100px;
          margin-bottom: 24px;
        }

        .rbl-title {
          font-family: "Changa One", sans-serif;
          font-size: clamp(32px, 5vw, 52px);
          font-weight: 400;
          line-height: 1.1;
          letter-spacing: -0.05em;
          margin: 0 0 18px;
        }

        .rbl-sub {
          font-size: 16px;
          font-weight: 400;
          line-height: 1.7;
          max-width: 480px;
          margin: 0 auto;
        }

        .rbl-cards {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 20px;
        }

        .rbl-card {
          border-radius: 20px;
          padding: 28px 24px 24px;
          cursor: pointer;
          position: relative;
          overflow: hidden;
          transition: border-color 0.3s ease, box-shadow 0.3s ease, transform 0.3s ease;
        }

        .rbl-card-glow {
          position: absolute;
          inset: 0;
          border-radius: 20px;
          opacity: 0;
          transition: opacity 0.4s ease;
          pointer-events: none;
          background: radial-gradient(ellipse at 50% 0%, var(--card-glow), transparent 70%);
        }
        .rbl-card:hover .rbl-card-glow,
        .rbl-card.active .rbl-card-glow {
          opacity: 1;
        }

        .rbl-card-top {
          display: flex;
          align-items: flex-start;
          justify-content: space-between;
          margin-bottom: 20px;
        }

        .rbl-card-icon-wrap {
          transition: transform 0.3s ease;
        }
        .rbl-card:hover .rbl-card-icon-wrap {
          transform: scale(1.08) translateY(-2px);
        }

        .rbl-card-label {
          font-family: 'DM Sans', sans-serif;
          font-size: 10px;
          font-weight: 700;
          letter-spacing: 0.1em;
          padding: 4px 10px;
          border-radius: 100px;
          align-self: flex-start;
          margin-top: 2px;
        }

        .rbl-card-title {
          font-family: 'Syne', sans-serif;
          font-size: 20px;
          font-weight: 700;
          margin: 0 0 4px;
          letter-spacing: -0.02em;
        }

        .rbl-card-sub {
          font-size: 12px;
          font-weight: 500;
          letter-spacing: 0.02em;
          margin-bottom: 14px;
        }

        .rbl-card-desc {
          font-size: 13.5px;
          line-height: 1.65;
          margin-bottom: 22px;
        }

        .rbl-card-divider {
          height: 1px;
          margin-bottom: 18px;
        }

        .rbl-card-bottom {
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 12px;
        }

        .rbl-card-cta {
          flex: 1;
          padding: 11px 18px;
          border-radius: 10px;
          font-family: 'DM Sans', sans-serif;
          font-size: 14px;
          font-weight: 600;
          cursor: pointer;
          border: none;
          transition: filter 0.2s ease, transform 0.2s ease;
          letter-spacing: 0.01em;
        }
        .rbl-card-cta:hover {
          transform: translateY(-1px);
        }
        .rbl-card-cta:active {
          transform: translateY(0);
        }

        .rbl-card-tag {
          font-size: 12px;
          font-weight: 500;
          white-space: nowrap;
          display: flex;
          align-items: center;
          gap: 4px;
        }

        .rbl-overlay {
          position: fixed;
          inset: 0;
          background: rgba(5,5,8,0.6);
          backdrop-filter: blur(6px);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 9999;
        }
        .rbl-spinner {
          width: 48px;
          height: 48px;
          border: 3px solid rgba(255,255,255,0.1);
          border-top-color: #00FFD1;
          border-radius: 50%;
          animation: spin 0.8s linear infinite;
        }
        @keyframes spin { to { transform: rotate(360deg); } }

        @media (max-width: 900px) {
          .rbl-cards {
            grid-template-columns: 1fr;
            max-width: 480px;
            margin: 0 auto;
          }
        }
      `}</style>

      <div className={`rbl-root ${theme}`}>
        <div className="rbl-bg-orb-1" />
        <div className="rbl-bg-orb-2" />
        <div className="rbl-bg-grid" />

        <div className="rbl-inner">
          <motion.div
            className="rbl-header"
            initial={{ opacity: 0, y: 24 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
          >
            <div className="rbl-badge">
              <SparkleIcon />
              ATS Resume Builder
            </div>
            <h1 className="rbl-title">
              How would you like<br />
              <span>to get started?</span>
            </h1>
            <p className="rbl-sub">
              Pick the fastest path to your new resume. Everything can be edited after.
            </p>
          </motion.div>

          <div className="rbl-cards">
            {METHODS.map((m, i) => {
              const isHov = hovered === m.id;
              const isSel = selectedMethod === m.id;

              return (
                <motion.div
                  key={m.id}
                  className={`rbl-card ${isHov || isSel ? 'active' : ''}`}
                  style={{
                    '--card-accent': m.accentDark,
                    '--card-accent-light': m.accent,
                    '--card-glow': isDark
                      ? `color-mix(in srgb, ${m.accentDark} 18%, transparent)`
                      : `color-mix(in srgb, ${m.accent} 12%, transparent)`,
                  }}
                  initial={{ opacity: 0, y: 32 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{
                    delay: 0.15 + i * 0.1,
                    duration: 0.55,
                    ease: [0.22, 1, 0.36, 1],
                  }}
                  whileHover={{ y: -6 }}
                  whileTap={{ scale: 0.985 }}
                  onHoverStart={() => setHovered(m.id)}
                  onHoverEnd={() => setHovered(null)}
                  onClick={() => handleSelect(m.id)}
                >
                  <div className="rbl-card-glow" />

                  <div className="rbl-card-top">
                    <div className="rbl-card-icon-wrap">{m.icon}</div>
                    <span className="rbl-card-label">{m.label}</span>
                  </div>

                  <div className="rbl-card-title">{m.title}</div>
                  <div className="rbl-card-sub">{m.subtitle}</div>
                  <p className="rbl-card-desc">{m.desc}</p>

                  <div className="rbl-card-divider" />

                  <div className="rbl-card-bottom">
                    <button
                      className="rbl-card-cta"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleSelect(m.id);
                      }}
                    >
                      {m.cta} →
                    </button>
                    <span className="rbl-card-tag">⏱ {m.tag}</span>
                  </div>
                </motion.div>
              );
            })}
          </div>
        </div>

        <AnimatePresence>
          {selectedMethod && (
            <motion.div
              className="rbl-overlay"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
            >
              <div className="rbl-spinner" />
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </>
  );
};

export default ResumeBuilderLanding;